import { PROCESS_QUEUE_EXERCISE_URL, No_START_OVER_URL, ASSESSMENT_SAVE_URL } from "./UrlManager";
import GLOBAL from "../../../../global";
import axios from '../../../../../src/services/Axios';
import { error, success } from "../../../../services/ResponseHandler";
import ErrorLogService from "../../../../services/ErrorLogService";

const RESPONSE_TYPE = { responseType: 'text' };

export const getQueuedMovements = async (testId) => {
    const requestUrl = `${PROCESS_QUEUE_EXERCISE_URL}`;
    let payload = {
        tenant: GLOBAL.TENANT,//VA PORTAL API
        testId: testId,
    }

    const errorPayload = ErrorLogService.createErrorLogPayload({
        Tenant: GLOBAL.TENANT || "Unknown_Tenant",
        Source: "AssessmentService",
        HelpLink: "",
        DeviceInfo: navigator.userAgent || "Unknown Device",
        RequestUrl: ASSESSMENT_SAVE_URL,
        TestId: testId,
        IncomingData: payload
    });

    try {
        const response = await axios.post(requestUrl, payload ,RESPONSE_TYPE);

        // Check if response status is not 200 and log error
        if(response && response.status && response.status !== 200) {
            errorPayload.StackTrace = `HTTP ${response.status} - ${response.statusText || 'Unknown Error'}`;
            errorPayload.Message = `Get exercise list failed with status ${response.status}`;

            await ErrorLogService.logError(errorPayload, { fireAndForget: true });
        }

        return response?.Message && response?.Message?.queue ? response?.Message.queue : [];
    } catch (err) {
        // Log error for axios network errors or other exceptions
        errorPayload.StackTrace = err.stack || err.toString();
        errorPayload.Message = `Video processing failed: ${err.message || 'Unknown error'}`;

        await ErrorLogService.logError(errorPayload, { fireAndForget: true });

        console.log(err);
        return [];
    }
}

export const getAddedRemovedExercises = async (testId) => {
    try {
        const requestUrl = `${PROCESS_QUEUE_EXERCISE_URL}`;
        const payload = {
            tenant: GLOBAL.TENANT, // VA PORTAL API
            testId: testId,
        };

        const response = await axios.post(requestUrl, payload, RESPONSE_TYPE);

        // console.log("from actual response", response);

        const message = response?.Message || {};

        return {
            queue: message.queue || [],
            addedExercises: message.AddedExercises || [],
            removedExercises: message.RemovedExercises || []
        };
    } catch (err) {
        console.error(err);
        return {
            queue: [],
            addedExercises: [],
            removedExercises: []
        };
    }
};

export const callStartOverApi = async (testId, patientId) => {//VA PORTAL API
    try {
        let payload = {
            tenant: GLOBAL.TENANT,//VA PORTAL API
            testId: testId,
            PatientId: patientId//VA PORTAL API
        }
        const response = await axios.post(No_START_OVER_URL, payload, RESPONSE_TYPE);
        return response;
    } catch (e) {
        console.log(e);
        return false;
    }
}